import * as API from "@/api/index.js"
import { NiIcon } from "@/ni-ui"
import Axios from "../common/mixin/axios_request"

export default {
  name: "base-tree",
  mixins: [Axios],
  components:{
    NiIcon,
  },

  model:{
    prop:"source_value",
    event:"data_change",
  },

  props:{

        default_props:{
          type: Object,
          default: function () {
            return {
              key: "key",     // node_key
              label: 'label',
              children: 'children',
              disabled: 'disabled',
              label_icon: 'label_icon',
              icon_title: 'icon_title',
            }    //相关配置数据
          },
        },

        type_field: {
            type: String,
            default: "type",    // 若各层级类型不一，此为类型区分的字段名
        },

        target_type: {
            type: String,
            default: "",     // 若各层级类型不一，此为选中数据的指定类型--类型区分字段的对应数据
        },

        source_value: "",

          // 配置是否可多选
        multiple: {
          type: Boolean,
          default: false,
        },

      // 显示复选框情况下，是否严格遵循父子不互相关联
        check_strictly: {
          type: Boolean,
          default: false,
        },


        data_loading: {   // 组件外部可控制loading
            type: Boolean,
            default: false,
        },

        data_url: {
            type: String,
            default: "",   // 源数据接口路由
        },

        data_param: null,  // 源数据接口参数

        default_checked_props:{  // 多选情况下才需考虑该字段
          type: Object,
          default: function () {
            return {
              leaf_only: false,     // 是否只是叶子节点
              include_half_checked: false,      // 是否包含半选节点
            }    //
          }
        },

        with_filter: {    // 是否可对tree数据检索
          type: Boolean,
          default: true,
        },

        first_expand_default: {  // 初始化时 是否默认展开首节点
          type: Boolean,
          default: false,
        },

        remote: {  // 是否为远程搜索
          type: Boolean,
          default: false,
        },

        remote_param_field: {   // 远程搜索时，对应的参数字段
          type: String,
          default: "",
        },

  },


  data(){
    return{
      target_value: "",
      target_nodes: null,
      checked_nodes: null,
      current_node: null,
      data: [],   // tree数据源
      loading: false,   // 页面loading
      req_loading: false,   // 表示数据加载时页面loading的状态
      only_data_loading: false,   // 数据源正在加载中
      last_target: null,

      filter_text: "",

      tree_props:{
        key: "key",
        label: 'label',
        children: 'children',
        disabled: 'disabled',
        label_icon: 'label_icon',
        icon_title: 'icon_title',
      },    // props_init()会初始化 tree_props的数据

      checked_props:{
        leaf_only: false,
        include_half_checked: false,
      },    // props_init()会初始化 checked_props的数据

      default_expanded_keys: [],
      is_first: true,   // 是否是新数据

      timer: null,



    }
  },

  created(){
    this.props_init()
  },


  mounted(){

    this.target_value = this.source_value;
    this.get_data();

  },

  watch:{
          source_value: {
            handler(data, old_data) {
              this.target_value = data
              this.last_target = old_data
              if(this.only_data_loading === false){
                this.set_current_node(data, old_data)
              }

            },
            deep: true
          },

          target_value: {
            handler(data) {
              this.$emit("data_change", data)
            },
            deep: true
          },

          data_loading(val){
            if (val || (!val && this.req_loading === false)) this.loading = val
          },

          req_loading(val){
            if (val || (!val && this.data_loading === false)) this.loading = val
          },

          filter_text(val) {
            if (!this.remote) this.$refs.tree.filter(val);
          },

          data_param:{
             handler(data) {

              this.get_data();
            },
            deep: true
          },

          data_url(val){
            this.get_data();
          },



  },

  computed:{


  },

  methods: {

    remote_filter_change(val){  // 根据输入内容进行过滤
      if(this.remote) this.get_data(val);
    },

    before_data_req(){
      clearTimeout(this.timer);
      var _this = this
      this.timer = setTimeout(() =>{
        _this.get_data();
      }, 500)
    },

    refresh(){
      this.get_data();
    },

    props_init(){
      for (var key in this.tree_props){
        if (this.default_props[key] !== undefined){
          this.tree_props[key] = this.default_props[key]
        }
      }
      for (var key in this.checked_props){
        if (this.default_checked_props[key] !== undefined){
          this.checked_props[key] = this.default_checked_props[key]
        }
      }
    },

    filter_node(value, data, node){
      if(this.remote) return;
      if (!value) return true;
      if (node.level > 1) return data[this.tree_props.label].indexOf(value) !== -1 || node.parent.data[this.tree_props.label].indexOf(value) !== -1;
      if (node.level === 1) return data[this.tree_props.label].indexOf(value) !== -1;
    },

    set_current_node(keys, old_keys){
      if (this.multiple){
        if (keys.length > 0 ){
          if (this.$refs.tree){
            let target_keys = []    // 手动‘setCheckedKeys’ 的数据
            let matched_keys = []    // ‘keys’中存在于tree的数据
            keys.map(key =>{
              let node = this.$refs.tree.getNode(key)
              if(node){
                matched_keys.push(key)
                if (this.checked_props.include_half_checked && node.isLeaf){
                  target_keys.push(key)
                }else if (!this.checked_props.include_half_checked){
                  target_keys.push(key)
                }
              }
            })
            this.$refs.tree.setCheckedKeys(target_keys)
            if (keys.length !== matched_keys.length){
              this.target_value = matched_keys
            }
          }

        }else {
          this.clear_selected_nodes(old_keys)
        }
      }else {
        if (keys){
          if(this.$refs.tree){
           let node = this.$refs.tree.getNode(keys)
            if (node){
              this.$refs.tree.setCurrentKey(keys)
              this.default_expanded_keys = [keys]
            }
          }

        }else {
          if (this.first_expand_default && this.is_first){
            this.is_first = false
            this.default_expanded_keys = []
            let target_key = this.expand_first(this.data, this.default_expanded_keys)
            let target_node = this.$refs.tree.getNode(target_key)
            if (target_node){
              this.set_target(target_node.data)
              this.$refs.tree.setCurrentKey(target_key)
            }
          }else {
            this.$refs.tree.setCurrentKey(null)
          }
        }

      }
    },

   //
    expand_first(data, expanded_keys){
      if (data.length > 0){
        let node = data[0]
        let node_key = node[this.tree_props.key]
        if (node[this.tree_props.children] && !this.is_target(node)){
          expanded_keys.push(node_key)
          return this.expand_first(node[this.tree_props.children], expanded_keys)
        }else if (this.is_target(node)){
          return node_key
        }
      }
    },

    // 多选，清空所有勾选
      clear_selected_nodes(keys) {
        if (!keys){
          return
        }
        for (let i = 0; i < keys.length; i++) {
          this.$refs.tree.setChecked(keys[i], false);
        }
      },

    handle_current_change(data, node){
      this.current_node = data;
    },

    handle_node_click(data, node){
      this.set_target(data)
      this.$emit('node-click', data, node)
    },

    set_target(data){
      if(!this.multiple){
        if(this.is_target(data)){
          this.target_value = data[this.tree_props.key];
          this.target_nodes = data;
        }else {
          this.target_value = "";
          this.target_nodes = null;
        }
        this.$emit('change', this.target_value, this.target_nodes);
      }else {

      }
    },


    is_target(data){
      if (!this.target_type || (this.target_type && data[this.type_field] === this.target_type )) return true
    },


    handle_check_change(node, checked, indeterminate){
      // getCheckedNodes(leafOnly, includeHalfChecked)  接收两个 boolean 类型的参数，1. 是否只是叶子节点，默认值为 false 2. 是否包含半选节点，默认值为 false
      this.target_nodes = this.$refs.tree.getCheckedNodes(this.checked_props.leaf_only, this.checked_props.include_half_checked);
      this.target_value = this.target_nodes.map(item => item[this.tree_props.key])
      this.checked_nodes = this.$refs.tree.getCheckedNodes();
      this.$emit('change', this.target_value, this.target_nodes)
      this.$emit('check-change', node, checked, this.target_nodes)
      // console.log(node, checked, indeterminate, this.target_nodes)

    },

    handle_check(data, node){
      this.$emit('check', data, node)
    },

    async get_data(filter_text) {
      this.data = []
      if (!this.data_url || this.data_param === null){
        return
      }
      let params = Object.assign({}, this.data_param)
      if(this.remote) params[this.remote_param_field] = filter_text;
        this.req_loading = true
        this.only_data_loading = true
        try {
          const response = await Axios.get(this.data_url, {params: params})
          this.req_loading = false
          if (response && response.data) {
            let data = response.data
            if (data.success){
              this.data = data.data
              this.$nextTick(() =>{
                this.only_data_loading = false
                this.is_first = true
                this.set_current_node(this.target_value, this.last_target)
              })
            }else {
              this.$message.error(data.msg)
              this.only_data_loading = false
            }
          }

        }catch (e) {
          console.log(e, params)
        }


      },
  }


}



// WEBPACK FOOTER //
// ./src/omnis-business/base-tree/base-tree.js